import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSectionsDndEditorComponent } from './fi-sections-dnd-editor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FiSectionDndItemsComponent } from './fi-section-dnd-items/fi-section-dnd-items.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiAppTextSharedModule } from '../app-text';
import { FiSectionsConfigService } from './services/fi-sections-config.service';
import { FiSectionsSummaryCardComponent } from './fi-sections-summary-card/fi-sections-summary-card.component';
import { FiSectionsHelperService } from './services/fi-sections-helper.service';
import { FiSectionEditDialogComponent } from './fi-section-edit-dialog/fi-section-edit-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        DragDropModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        InfoIconModule,
        FiIconTooltipButtonModule,
        MatMenuModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        FiNameInputModule,
    ],
    declarations: [
        FiSectionsDndEditorComponent,
        FiSectionDndItemsComponent,
        FiSectionsSummaryCardComponent,
        FiSectionEditDialogComponent,
    ],
    exports: [FiSectionsDndEditorComponent, FiSectionsSummaryCardComponent, FiSectionEditDialogComponent],
    providers: [FiSectionsConfigService, FiSectionsHelperService],
})
export class FiSectionsDndEditorModule {}
